import { EntityModel } from '@/interfaces'
import {
  ALL_FIELD_OPTIONS_QUERY,
  CREATE_FIELD_OPTION_MUTATION,
  DELETE_FIELD_OPTION_MUTATION,
  FORCE_DELETE_FIELD_OPTION_MUTATION,
  SINGLE_FIELD_OPTION_QUERY,
  UPDATE_FIELD_OPTION_MUTATION,
} from './graphql'

const customBookingFormFieldOptionModel: EntityModel = {
  name: 'fieldOption',
  namePlural: 'fieldOptions',
  uniqueName: 'customBookingFormFieldOption',
  uniqueNamePlural: 'customBookingFormFieldOptions',
  path: 'travel/booking/custom_data/field_option',
  baseUrl: '/travel/booking/custom_data/field_options',
  translationPrefix: 'entities:customBookingFormFieldOption.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_FIELD_OPTIONS_QUERY,
    getSingle: SINGLE_FIELD_OPTION_QUERY,
    create: CREATE_FIELD_OPTION_MUTATION,
    update: UPDATE_FIELD_OPTION_MUTATION,
    delete: DELETE_FIELD_OPTION_MUTATION,
    forceDelete: FORCE_DELETE_FIELD_OPTION_MUTATION,
  },
  attributes: {
    value: {
      name: 'value',
      label: 'entities:customBookingFormFieldOption.attributes.value.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:customBookingFormFieldOption.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default customBookingFormFieldOptionModel
